import type { AvatarConnectionStatus } from '@shared/types';

const STATUS_LABELS: Record<AvatarConnectionStatus, string> = {
  'not-connected': 'Not Connected',
  connecting: 'Connecting…',
  connected: 'Connected',
  error: 'Error',
};

export function getAvatarStatusLabel(status: AvatarConnectionStatus): string {
  return STATUS_LABELS[status];
}
